/** @jsx isolateComponent */

import { css } from '@emotion/core';

import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

const Styles = labelStyles('YouTubeVideo', {
  root: css`
    position: relative;
    width: 100%;
    height: 0;
  `,
  video: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  `,
});

type Props = {
  /**
   * The ID of the video to be displayed. For example: in the URL
   * `https://www.youtube.com/watch?v=QEmNOlXf-HY`, it would be `QEmNOlXf-HY`.
   */
  youTubeId: string;
  /**
   * The title of the video.
   */
  title: string;
  /**
   * Aspect ratio at which to render the video.
   */
  aspectRatio: number;
  /**
   * Whether to automatically start playing the video.
   * When `true`, the video will autoplay in browsers that permit it.
   */
  autoplay: boolean;
  /**
   * Whether to allow the video to be displayed full screen.
   * When `true`, allow the user to view the video in fullscreen mode.
   */
  allowFullscreen: boolean;
};

export const YouTubeVideo = (props: Props) => {
  const style = {
    paddingBottom: `${props.aspectRatio ** -1 * 100}%`,
  };
  return (
    <div css={Styles.root} style={style}>
      <iframe
        allow={props.allowFullscreen ? 'fullscreen' : undefined}
        css={Styles.video}
        frameBorder="0"
        // ?rel=0 makes only videos by Zapier show as related videos
        src={`https://www.youtube.com/embed/${
          props.youTubeId
        }?rel=0&autoplay=${Number(props.autoplay)}`}
        title={props.title}
      ></iframe>
    </div>
  );
};

YouTubeVideo.defaultProps = {
  aspectRatio: 16 / 9,
  autoplay: true,
  allowFullscreen: true,
};
